/**
 * Guest emails. Subjects and leads can be overridden per restaurant and
 * language; these are the defaults. Placeholders: {guest} {restaurant} {when}
 * {party} {code} {fee}.
 */
export const enEmail = {
  'email.greeting': 'Hello {guest},',
  'email.greeting_anon': 'Hello,',
  'email.row.restaurant': 'Restaurant',
  'email.row.when': 'When',
  'email.row.party': 'Party',
  'email.row.code': 'Confirmation code',
  'email.party_one': '{n} guest',
  'email.party_other': '{n} guests',
  'email.link.manage': 'View or cancel your reservation',
  'email.link.rebook': 'Book another time',
  'email.footer.contact': 'Questions? {contact}',
  'email.footer.phone': 'Phone: {phone}',
  'email.footer.email': 'Email: {email}',
  'email.footer.address': 'Address: {address}',
  'email.footer.website': 'Website: {website}',
  'email.confirmation.subject': 'Your reservation at {restaurant}: {when}',
  'email.confirmation.lead': 'Your table is confirmed. We look forward to seeing you.',
  'email.reminder.subject': 'Reminder: {restaurant}, {when}',
  'email.reminder.lead':
    'A friendly reminder of your reservation. If your plans have changed, please cancel so we can offer the table to someone else.',
  'email.change.subject': 'Your reservation at {restaurant} was updated',
  'email.change.lead': 'Your reservation was changed. The details below are the current ones.',
  'email.cancellation.subject': 'Your reservation at {restaurant} was cancelled',
  'email.cancellation.lead': 'Your reservation has been cancelled. No charge applies.',
  'email.cancellation.lead_fee': 'Your reservation has been cancelled. Under the cancellation policy, {fee} applies.',
  'email.policy.deposit':
    'A deposit of {amount} was taken. It is refunded if you cancel at least {hours} hours ahead, and kept for a late cancellation or no-show.',
  'email.policy.card':
    'Your card is on file and nothing has been charged. Up to {amount} may be charged for a no-show or a cancellation within {hours} hours.',
  'sms.table_ready': '{restaurant}: Hello {guest}, your table is ready. Please come to the host stand.',
  'sms.running_late': '{restaurant}: Hello {guest}, we are holding your table. Please let us know when you will arrive.',
  'notify.new': 'New reservation from {guest}',
  'notify.cancelled': 'Cancellation from {guest}',
  "alert.subject": "{restaurant}: a table is available",
  "alert.body": "Hello {guest}, a table for {party} on {date} has become available at {restaurant}. Book it here before it is gone:",
  "pr.subject_new": "New private dining request from {guest}",
  "pr.subject_status": "{restaurant}: your private dining request",
  "pr.quoted": "Hello {guest}, thank you for your request for {date}. Our offer is {amount}{deposit}. Please reply to this email to accept.",
  "pr.confirmed": "Hello {guest}, your private dining event on {date} is confirmed. We look forward to hosting you.",
  "pr.declined": "Hello {guest}, unfortunately we cannot host your event on {date}. Thank you for thinking of us.",
  "pr.deposit": ", with a deposit of {deposit}",
  "mk.unsub": "You are receiving this because you agreed to hear from {restaurant}. Unsubscribe: {link}",
  'email.review.subject': 'How was your visit to {restaurant}?',
  'email.review.lead': 'Thank you for visiting {restaurant}. If you enjoyed it, a short review helps other guests find us.',
  'email.link.review': 'Leave a review',
  'email.unsubscribe': 'You receive this because you agreed to hear from us. Unsubscribe: {link}',
  'p.list_title': 'Day list',
  'p.cards_title': 'Table cards',
  'p.time': 'Time',
  'p.table': 'Table',
  'p.party': 'Pers.',
  'p.guest': 'Guest',
  'p.notes': 'Notes',
  'p.shift_notes': 'Shift notes',
  'p.closed': 'Closed',
  'p.parties': 'parties',
  'p.covers': 'guests',
  'p.total': 'Total',
  'p.none': 'No reservations.',
  'p.legend': '[Card] = card on file or deposit. Tick the box when the party is seated.',
  'p.card_name': 'Guest name:',
  'p.card_mark': 'Card',
  'p.daily_subject': '{restaurant}: sheets for {date}',
  'p.daily_body': 'Good morning. Attached: the day list and the table cards for {date} ({parties} reservations, {covers} guests).',
  'notify.when': 'When',
  'notify.party': 'Party size',
  'notify.code': 'Reference',
  'notify.phone': 'Phone',
  'notify.request': 'Request',
  'notify.large': 'This is a large party.',
  'notify.subject_new': 'new reservation, {guest}, {party} guests',
  'notify.subject_cancel': 'cancellation, {guest}, {party} guests',
} as const;
